enum SolarLeaderboardSiteSource {
  Internal = 'Black Bear (internal)',
  SEIA_SingleSite = 'SEIA - single site',
  REIT = 'REIT',
  Other = 'Other',
}

export default SolarLeaderboardSiteSource;
